import React, { Component } from 'react';
import PT from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import PrimaryDropdown from '../../components/FilterComponents/PrimaryDropdown';
import FiltersHeader from '../../components/FiltersHeader';
import ButtonMenu from '../../components/FilterComponents/ButtonMenu';
import DataTable from '../../components/DataTable';
import TableControls from '../../components/TableControls';
import { selectControlsState } from '../../../store/reducers/tableControls';
import { DataPT } from '../../components/DataTable/DataTable.proptypes';
import { DropdownOptionsType } from '../../../lib/proptypes/semantic';
import { selectTrackedPlayers } from '../../../store/reducers/tracking';
import { selectAuthState } from '../../../store/actions/auth.actions';
import { goToView } from '../../routes.global';
import {
  BOX_SCORES_VIEW,
  selectBoxScoresState,
} from './module/boxScores';
import { selectTeamsForDropdownAlpha, filterTeams } from '../../../store/reducers/teams.selectors';
import {
  selectMapNewDropdown,
  selectMapOldDropdown,
  selectWeeksForDropdown,
  selectWeeksNewWithPreSeasonForDropdown
} from '../../../store/reducers/season';
import { selectMatchupsForDropdown, loadMatchups } from '../../../store/reducers/matchups';
import classes from './BoxScores.css';
import {
  selectToolDescriptionsState,
} from '../../../store/reducers/toolDescriptions';
import { ToolDescription } from '../../components/ToolDescriptions/ToolDescriptions';
import { gciPageView } from '../../../lib/analytics';

const pageTitle = 'Fantasy Box Scores';
// const log = debug('huddle:app:views:box-scores');
const filterTypeOptions = [
  { name: 'WEEKLY', value: 'Weekly' },
  { name: 'SEASON-TO-DATE BY TEAM', value: 'Season' },
];

var teamTable = [];
var matchupTableObject = {};
var gamesTableArray = [];

const mapStateToProps = state => {
  const {
    team,
    matchup,
    year,
    formulaId,
    filterType,
    week,
    boxScores,
    hasLoaded,
  } = selectBoxScoresState(state);
  const {
    toolDescriptions,
    toolsLoaded,
  } = selectToolDescriptionsState(state);

  state.teams = filterTeams(state.teams);
  const loggedIn = state.auth.loggedIn;
  var mapfunc = selectMapOldDropdown;
  if ( year >= 2021 ) {
    mapfunc = selectMapNewDropdown;
  }

  return {
    hasLoaded,
    loggedIn,
    selectedTeam: team,
    selectedMatchup: matchup,
    selectedYear: year,
    selectedProfile: formulaId,
    selectedWeek: week,
    selectedFilterType: filterType,
    weeks: mapfunc(state, year, 'projections'),
    matchups: selectMatchupsForDropdown(state, year, week),
    teams: selectTeamsForDropdownAlpha(state),
    tableData: boxScores,
    trackedPlayers: selectTrackedPlayers(state),
    collapsed: selectControlsState(state).collapsed,
    toolDescriptions,
    toolsLoaded,
  };
};
const actions = {
  goToView,
  loadMatchups,
};


// putting here to prevent re-creating on every render
const colGroups = [
  { name: '', columns: ['player', 'position'] },
  { name: 'total', columns: ['FFPTS', 'PLAYS'] },
  { name: 'rushing', columns: ['RUATT', 'RUYDS', 'RUTDS'] },
  { name: 'passing/receiving', columns: ['PAATT\nTRGT', 'PACMP\nREC', 'PAYDS\nRCYDS', 'PATDS\nRCTDS'] },
  { name: 'to', columns: ['FUML', 'INT'] },
];

const colReplacements = {
  PAATT: 'PAATT\nTRGT',
  TRGT: 'PAATT\nTRGT',
  PACMP: 'PACMP\nREC',
  REC: 'PACMP\nREC',
  PAYDS: 'PAYDS\nRCYDS',
  RCYDS: 'PAYDS\nRCYDS',
  PATDS: 'PATDS\nRCTDS',
  RCTDS: 'PATDS\nRCTDS',
};

teamTable = new Array();

const statKeys = [
  { name: 'total', columns: ['FFPTS', 'PLAYS', 'RUATT', 'RUYDS', 'RUTDS', 'PAATT', 'TRGT', 'PACMP', 'REC', 'PAYDS', 'RCYDS', 'PATDS', 'RCTDS', 'FUML', 'INT'] },
];

class BoxScores extends Component {
  static propTypes = {
    hasLoaded: PT.bool.isRequired,
    selectedYear: PT.number,
    selectedProfile: PT.number.isRequired,
    selectedTeam: PT.number,
    selectedFilterType: PT.string,
    selectedWeek: PT.number,
    selectedMatchup: PT.number,
    teams: PT.arrayOf(PT.shape({
      id: PT.number,
      key: PT.string,
      text: PT.string,
      abbr: PT.string,
    })).isRequired,
    weeks: DropdownOptionsType.isRequired,
    tableData: DataPT.isRequired,
    trackedPlayers: PT.arrayOf(PT.number).isRequired,
    goToView: PT.func.isRequired,
    matchups: DropdownOptionsType.isRequired,
    loggedIn: PT.bool.isRequired,
    toolsLoaded: PT.bool.isRequired,
    gciPageView: PT.func.isRequired,
  }
  static defaultProps = {
    loggedIn: false,
    selectedYear: null,
    selectedTeam: null,
    selectedWeek: null,
    selectedMatchup: null,
    selectedFilterType: null,
  }

  handleChangeYear = (event, { value }) => {
    if (this.props.selectedYear !== value) {
      this.props.goToView(BOX_SCORES_VIEW, {
        query: {
          year: value,
          filterType: this.props.selectedFilterType
        },
        updateQuery: false
      });
    }
  }

  handleChangeProfile = (event, { value }) => {
    if (this.props.selectedProfile !== value) {
      this.props.goToView(BOX_SCORES_VIEW, { query: { formulaId: value } });
    }
  }

  handleChangeTeam = (event, { value }) => {
    if (this.props.selectedTeam !== value) {
      this.props.goToView(BOX_SCORES_VIEW, { query: { team: value } });
    }
  }

  handleChangeFilterType = (event, { value }) => {
    if (this.props.selectedFilterType !== value) {
      this.props.goToView(BOX_SCORES_VIEW, { query: { filterType: value } });
    }
  }

  handleChangeWeek = (event, { value }) => {
    if (this.props.selectedWeek !== value) {
      this.props.goToView(BOX_SCORES_VIEW,
        {
          query: {
            week: value,
            year: this.props.selectedYear,
            formulaId: this.props.selectedProfile,
            filterType: this.props.selectedFilterType
          },
          updateQuery: false,
        });
    }
  }

  handleChangeMatchup = (event, { value }) => {
    if (this.props.selectedMatchup !== value) {
      this.props.goToView(BOX_SCORES_VIEW,
        {
          query: {
            matchup: value,
          }
        });
    }
  }

  isWeekly = () => this.props.selectedFilterType === 'Weekly';

  prepPositionSort = () => {
    // Need to sort by specified position order (QB, RB, WR, TE), then by the # of plays
    // We want to sort by the following positions
    const ordering = {
      QB: 1,
      RB: 2,
      WR: 3,
      TE: 4,
    };

    // Get the data ready
    const { tableData } = this.props;
    gamesTableArray = [];

    // For each game
    tableData.forEach((game, index) => {
      // Ugly, but the only way I could find to
      // game.player_stats.sort(function(a, b) {return a.order - b.order});

      teamTable = [];

      // For each player order by position and set the number of plays
      game.player_stats.forEach(player => {
        player.order = ordering[player.position];
        player.playsCount = this.checkForPlays(player.stats);
        // console.log('player.playsCount ', player.playsCount);
        player.points = player.fpts;
        player.stats.forEach(el => { if (colReplacements[el.stat_abbr]) el.stat_abbr = colReplacements[el.stat_abbr] });
        if (player.playsCount > 0) {
          teamTable.push(player);
        }
      });

      gamesTableArray.push({
        'game_id': tableData[index].game_id,
        'home_team_id': tableData[index].home_team_id,
        'away_team_id': tableData[index].away_team_id,
        'week': tableData[index].week,
        'player_stats': teamTable
      });

      // sort by fantasy points within each position
      gamesTableArray[index].player_stats.sort(function (a, b) {
        if (a.order - b.order === 0) {
          return b.points - a.points;
        } else {
          return a.order - b.order;
        }
      });

    });

  };

  prepPositionSorth2h = (teamid, teams) => {
    // Need to sort by specified position order (QB, RB, WR, TE), then by the # of plays
    // We want to sort by the following positions
    const ordering = {
      QB: 1,
      RB: 2,
      WR: 3,
      TE: 4,
    };

    // Get the data ready
    const { tableData } = this.props;
    var teamAbbr = '';

    teams.forEach(team => {
      if (teamid == team.value) {
        teamAbbr = team.key;
      }
    });

    // For each game
    tableData.forEach(game => {
      teamTable = [];
      // Ugly, but the only way I could find to
      // game.player_stats.sort(function(a, b) {return a.order - b.order});

      // build a new array to assign all players to the correct team for home vs. away
      for (var i = 0; i < game.player_stats.length; i++) {
        var playsCount = this.checkForPlays(game.player_stats[i].stats);
        if (game.player_stats[i].team == teamAbbr && playsCount != 0) {
          teamTable.push(game.player_stats[i]);
        }
      }

      // For each player order by position and set the number of plays
      teamTable.forEach((player, i, object) => {
        player.order = ordering[player.position];
        player.points = player.fpts;
        player.stats.forEach(el => { if (colReplacements[el.stat_abbr]) el.stat_abbr = colReplacements[el.stat_abbr] });
      });

      // sort by fantasy points within each position
      var newTable = [{ 'game_id': tableData[0].game_id, 'home_team_id': tableData[0].home_team_id, 'away_team_id': tableData[0].away_team_id, 'player_stats': teamTable }];

      matchupTableObject = Object.assign({}, newTable[0]);

      matchupTableObject.player_stats.sort(function (a, b) {
        if (a.order - b.order === 0) {
          return b.fpts - a.fpts;
        } else {
          return a.order - b.order;
        }
      });
    });

  };

  getTeamAbbr(teamid, teams) {
    var teamAbbr = 'Unavailable';
    teams.forEach(team => {
      if (teamid == team.value) {
        teamAbbr = team.key;
      }
    });
    return teamAbbr;
  }

  checkForPlays(stats) {
    var plays = 0;
    var playsObj = {};
    playsObj = stats.find(el => el.stat_abbr === 'PLAYS');
    if (playsObj) {
      plays = playsObj.stat_value_total;
    }
    return plays;
  }

  render() {
    const {
      tableData,
      trackedPlayers,
      teams,
      weeks,
      loggedIn,
      matchups,
      selectedYear,
      selectedProfile,
      selectedTeam,
      selectedWeek,
      selectedFilterType,
      selectedMatchup,
      hasLoaded,
      toolDescriptions,
      toolsLoaded,
    } = this.props;

    // for collapsed
    const wrapperClass = classNames(
      classes.tableStyle,
      { [classes.collapsed]: this.props.collapsed },
    );

    var empty = false;

    const teamsDropdown = (
      <PrimaryDropdown
        label={'Team:'}
        selection
        activeItem={selectedTeam}
        choices={teams}
        onChange={this.handleChangeTeam}
      />
    );

    const weeksDropdown = (
      <PrimaryDropdown
        label={'Week:'}
        selection
        activeItem={selectedWeek}
        choices={weeks}
        onChange={this.handleChangeWeek}
      />
    );

    const matchupsDropdown = (
      <PrimaryDropdown
        label={'Matchup:'}
        selection
        activeItem={selectedMatchup}
        choices={matchups.filter(matchup => matchup.text !== 'IP_ at IP_')}
        onChange={this.handleChangeMatchup}
      />
    );

    const headline = (selectedFilterType === 'Season' ? 'Season-to-date, by team' : 'Weekly');

    var homeTableData = new Object();
    var awayTableData = new Object();

    if (selectedFilterType == 'Weekly') {
      if (this.props.tableData.length != 0) {
        // prep home and away before table render
        this.prepPositionSorth2h(this.props.tableData[0].home_team_id, teams);
        homeTableData = matchupTableObject;

        this.prepPositionSorth2h(this.props.tableData[0].away_team_id, teams);
        awayTableData = matchupTableObject;
      } else {
        empty = true;
      }
    } else {
      // season-to-date by team
      this.prepPositionSort();
    }

    if (matchups.length === 0) {
      empty = true;
    }

    return (
      <div className={classes.wrapper}>
        <FiltersHeader
          title={pageTitle + ': ' + headline}
          description={toolsLoaded && toolDescriptions.tool_descriptions.box_scores.visible == 1 && (
            <ToolDescription
              descr={toolDescriptions.tool_descriptions.box_scores.text}
            />)}
          seasonType={selectedWeek === 0 ? 'preseasons' : 'seasons'}
          statType={'stats'}
          selectedYear={selectedYear}
          selectedProfile={selectedProfile}
          onChangeProfile={this.handleChangeProfile}
          onChangeYear={this.handleChangeYear}
        >
          <ButtonMenu
            choices={filterTypeOptions}
            activeItem={selectedFilterType}
            onChange={this.handleChangeFilterType}
            variableWidth
          />
          <div> {/* empty on purpose */} </div>
          {this.isWeekly() ? weeksDropdown : teamsDropdown}
          {this.isWeekly() && matchupsDropdown}
        </FiltersHeader>
        <TableControls colGroups={statKeys} injury density track compare legend loggedIn={loggedIn} />
        {(hasLoaded && selectedFilterType == 'Weekly' && !empty) &&
          <div>
            <div id='awayTable'>
              <DataTable
                density
                track
                compare
                legend
                injury
                selectedLeague={selectedProfile}
                teams={teams}
                className={wrapperClass}
                colGroups={colGroups}
                data={[awayTableData]}
                trackedPlayers={trackedPlayers}
                initialSortColumn={'order'}
              />
            </div>
            <div id='homeTable'>
              <DataTable
                density
                track
                compare
                legend
                injury
                selectedLeague={selectedProfile}
                teams={teams}
                className={wrapperClass}
                colGroups={colGroups}
                data={[homeTableData]}
                trackedPlayers={trackedPlayers}
                initialSortColumn={'order'}
              />
            </div>
          </div>
        }
        {(empty) &&
          <div className={classes.noResults}>No data available for the current criteria. Please try adjusting the filters above.</div>
        }
        {(hasLoaded && selectedFilterType != 'Weekly') &&
          <div id='awayTable'>
            <DataTable
              density
              track
              compare
              legend
              injury
              selectedLeague={selectedProfile}
              teams={teams}
              className={wrapperClass}
              colGroups={colGroups}
              data={gamesTableArray}
              trackedPlayers={trackedPlayers}
              initialSortColumn={'order'}
            />
          </div>
        }
      </div>
    );
  }

  componentDidMount() {
    document.title = pageTitle + ' - TheHuddle';
    gciPageView(pageTitle);
  }
}

export default connect(mapStateToProps, actions)(BoxScores);



// WEBPACK FOOTER //
// ./src/app/views/BoxScores/BoxScores.js